export default function classNames(...classess) {
  return classess.join(' ').trim();
}
